export const SHIPPING_ORIGINS = [
  { code: 'MY_PLACE', label: 'My place', address: '', pickupPincode: '110001', city: 'New Delhi', state: 'Delhi', region: 'north', nearbyPincodePrefixes: ['121'], active: true, sortOrder: 1 },
  { code: 'PETI', label: 'Peti', address: '', pickupPincode: '400001', city: 'Mumbai', state: 'Maharashtra', region: 'west', active: true, sortOrder: 2 },
  { code: 'HELLA', label: 'Hella', address: '', pickupPincode: '560001', city: 'Bengaluru', state: 'Karnataka', region: 'south', active: true, sortOrder: 3 },
];

const ORIGIN_ALIASES = { DELHI_NCR: 'MY_PLACE', MUMBAI: 'PETI', BENGALURU: 'HELLA' };

export const normalizeOriginCode = (value) => {
  const normalized = String(value || '').trim().toUpperCase().replace(/[^A-Z0-9_]+/g, '_').replace(/^_+|_+$/g, '').slice(0, 40);
  const canonical = ORIGIN_ALIASES[normalized] || normalized;
  return /^[A-Z][A-Z0-9_]{1,39}$/.test(canonical) ? canonical : 'MY_PLACE';
};
